import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import {injectIntl} from 'react-intl';
import {VM} from '@hetao/scratch-core';
// import AudioEngine from 'scratch-audio';

import AssetPanel from '../components/asset-panel-ht/asset-panel.jsx';
import soundIcon from '../components/asset-panel/icon--sound.svg';

import RecordModal from './record-modal.jsx';
import SoundLibrary from './sound-library.jsx';
import SoundEditorModal from '../components/sound-editor-modal/sound-editor-modal.jsx';

import soundLibraryContent from '../lib/libraries/sounds.json';
import {handleFileUpload, soundUpload} from '../lib/file-uploader.js';
import errorBoundaryHOC from '../lib/error-boundary-hoc.jsx';
import DragConstants from '../lib/drag-constants';
import {getHomeworkInfo} from '../lib/homework-info';
import {showStandardAlert, closeAlertWithId} from '../reducers/alerts';

import {connect} from 'react-redux';
import AudioBlobPlayer from '../lib/audio/audio-blob-player'

import {
    closeSoundLibrary,
    openSoundEditor,
    openSoundLibrary,
    openSoundRecorder
} from '../reducers/modals';

import {
    activateTab,
    COSTUMES_TAB_INDEX
} from '../reducers/editor-tab';

class SoundPanel extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleSelectSound',
            'handleDeleteSound',
            'handleDuplicateSound',
            'handleNewSound',
            'handleSurpriseSound',
            'handleFileUploadClick',
            'handleSoundUpload',
            'handleSoundPlay',
            'handleDrop',
            'handleUpdateName',
            'setFileInput',
            'stopPlayingSound',
            'handleStoppedPlaying',
            'handleEditSound',
            'handleSoundStop'
        ]);
        const {
            editingTarget,
            sprites,
            stage
        } = props;
        const target = editingTarget && sprites[editingTarget] ? sprites[editingTarget] : stage;

        this.state = {selectedSoundIndex: 0, playingIndex: -1, disabled: target.disabled};
        this.audioBufferPlayer = null;

        // /**
        //  * AudioEngine that will decode and play sounds for us.
        //  * @type {AudioEngine}
        //  */
        // this.audioEngine = null;
        /**
         * A promise for the sound queued to play as soon as it loads and
         * decodes.
         * @type {Promise<SoundPlayer>}
         */
        this.playingSoundPromise = null;
    }

    componentDidMount () {

    }

    componentWillReceiveProps (nextProps) {
        const {
            editingTarget,
            sprites,
            stage
        } = nextProps;

        const target = editingTarget && sprites[editingTarget] ? sprites[editingTarget] : stage;
        if (!target || !target.sounds) {
            return;
        }

        // 如果声音在播放，则停止
        if (this.props.soundLibraryVisible !== nextProps.soundLibraryVisible && nextProps.soundLibraryVisible) {
            if (this.state.playingIndex > -1) {
                this.handleSoundStop();
            }
        }

        // If switching editing targets, reset the sound index
        if (this.props.editingTarget !== editingTarget) {
            this.setState({selectedSoundIndex: 0});
        } else if (this.state.selectedSoundIndex > target.sounds.length - 1) {
            this.setState({selectedSoundIndex: Math.max(target.sounds.length - 1, 0)});
        }
    }

    componentWillUnmount () {
        if (this.audioBufferPlayer) this.audioBufferPlayer.stop();
    }
    handleUpdateName (name) {
        this.props.vm.renameSound(this.state.selectedSoundIndex, name);
        // qjn added. emit an event mainly for telling blocks to update
        this.props.vm.emit('costumeNameUpdated', null);
        // 拓展中的语音积木块“用普通话识别声音”可能需要它更新拓展信息，这个积木块也许也没人用了
        this.props.vm.runtime.emit('TOOLBOX_EXTENSIONS_NEED_UPDATE');
    }
    handleSelectSound (soundIndex) {
        this.setState({selectedSoundIndex: soundIndex});
    }

    handleDeleteSound (soundIndex) {
        if (this.handleDisabled()) {
            return;
        }
        // 如果要删除的可能会影响当前正在播放音乐的索引，则停止掉
        if (soundIndex <= this.state.playingIndex) {
            this.handleSoundStop();
        }
        this.props.vm.deleteSound(soundIndex);
        if (soundIndex >= this.state.selectedSoundIndex) {
            this.setState({selectedSoundIndex: Math.max(0, soundIndex - 1)});
        }
    }

    handleDuplicateSound (soundIndex) {
        if (this.handleDisabled()) {
            return;
        }
        this.props.vm.duplicateSound(soundIndex).then(() => {
            this.setState({selectedSoundIndex: soundIndex + 1});
        });
    }

    handleNewSound () {
        if (!this.props.vm.editingTarget) {
            return null;
        }
        const sprite = this.props.vm.editingTarget.sprite;
        const sounds = sprite.sounds ? sprite.sounds : [];
        this.setState({selectedSoundIndex: Math.max(sounds.length - 1, 0)});
    }

    handleSoundPlay (soundIndex) {
        this.setState({
            playingIndex: soundIndex
        });
        if (this.audioBufferPlayer) this.audioBufferPlayer.release();
        const soundPlayer = this.props.vm.getSound(soundIndex);
        this.audioBufferPlayer = new AudioBlobPlayer(soundPlayer.blob);
        this.audioBufferPlayer.play(this.handleStoppedPlaying);
    }

    handleSoundStop (){
        if (this.audioBufferPlayer) this.audioBufferPlayer.stop();
        this.setState({
            playingIndex: -1
        });
    }

    handleStoppedPlaying () {
        this.setState({playingIndex: -1});
    }

    handleSurpriseSound () {
        if (this.handleDisabled()) {
            return;
        }
        const soundItem = soundLibraryContent[Math.floor(Math.random() * soundLibraryContent.length)];
        const vmSound = {
            format: soundItem.format,
            md5: soundItem.md5,
            rate: soundItem.rate,
            sampleCount: soundItem.sampleCount,
            name: soundItem.name
        };
        this.props.vm.addSound(vmSound).then(() => {
            this.handleNewSound();
        });
    }

    handleFileUploadClick () {
        if (this.handleDisabled()) {
            return;
        }
        const editingTarget = this.props.vm.editingTarget;
        const id = editingTarget.id;
        const name = editingTarget.sprite.name.toLowerCase();
        const category = editingTarget.isStage ? 'stage' : 'sprite';
        const homeworkInfo = getHomeworkInfo();
        const courseId = Number(homeworkInfo.courseId);
        const unitId = Number(homeworkInfo.unitId);
        const lessonId = Number(homeworkInfo.lessonId);
        const param = editingTarget.isStage ? {stage: {id: id, name: name}} : {sprite: {id: id, name: name}};
        ht.track(`s3_${category}_sound_upload`, {
            context: {
                courseId: courseId,
                unitId: unitId,
                lessonId: lessonId,
                currentUrl: location.href,
                stageDisplayMode: localStorage.getItem('stageDisplayMode')
            },
            param: param

        });
        this.fileInput.click();
    }

    handleSoundUpload (e) {
        const storage = this.props.vm.runtime.storage;
        this.props.onShowImporting();
        handleFileUpload(e.target, (blob, fileType, fileName, fileIndex, fileCount) => {
            soundUpload(blob, fileType, storage, newSound => {
                newSound.name = fileName;
                this.props.vm.addSound(newSound).then(() => {
                    this.handleNewSound();
                    if (fileIndex === fileCount - 1) {
                        this.props.onCloseImporting();
                    }
                });
            });
        }, this.props.onCloseImporting);
    }

    handleDrop (dropInfo) {
        if (dropInfo.dragType === DragConstants.SOUND) {
            const sprite = this.props.vm.editingTarget.sprite;
            const activeSound = sprite.sounds[this.state.selectedSoundIndex];

            this.props.vm.reorderSound(this.props.vm.editingTarget.id,
                dropInfo.index, dropInfo.newIndex);

            this.setState({selectedSoundIndex: sprite.sounds.indexOf(activeSound)});
        } else if (dropInfo.dragType === DragConstants.BACKPACK_COSTUME) {
            this.props.onActivateCostumesTab();
            this.props.vm.addCostume(dropInfo.payload.body, {
                name: dropInfo.payload.name
            });
        } else if (dropInfo.dragType === DragConstants.BACKPACK_SOUND) {
            this.props.vm.addSound({
                md5: dropInfo.payload.body,
                name: dropInfo.payload.name
            }).then(this.handleNewSound);
        }
    }

    handleEditSound (soundIndex) {
        this.handleSoundStop();
        this.handleSelectSound(soundIndex);
        this.props.onRequestOpenSoundEditor();
    }

    stopPlayingSound () {
        // Playback is queued, playing, or has played recently and finished
        // normally.
        if (this.playingSoundPromise) {
            // Queued playback began playing before this method.
            if (this.playingSoundPromise.isPlaying) {
                // Fetch the player from the promise and stop playback soon.
                this.playingSoundPromise.then(soundPlayer => {
                    soundPlayer.stop();
                });
            } else {
                // Fetch the player from the promise and stop immediately. Since
                // the sound is not playing yet, this callback will be called
                // immediately after the sound starts playback. Stopping it
                // immediately will have the effect of no sound being played.
                this.playingSoundPromise.then(soundPlayer => {
                    soundPlayer.stopImmediately();
                });
            }
            // No further work should be performed on this promise and its
            // soundPlayer.
            this.playingSoundPromise = null;
        }
    }

    setFileInput (input) {
        this.fileInput = input;
    }

    handleDisabled () {
        if (this.state.disabled) {
            alert('不要改动老师已经写好的角色，会影响你正常过关'); // eslint-disable-line
            return true;
        }
        return false;
    }

    render () {
        const {
            vm
        } = this.props;

        if (!vm.editingTarget) {
            return null;
        }

        const sprite = vm.editingTarget.sprite;

        const sounds = sprite.sounds ? sprite.sounds.map(sound => (
            {
                url: soundIcon,
                name: sound.name,
                details: (sound.sampleCount / sound.rate).toFixed(2),
                dragPayload: sound
            }
        )) : [];

        return (
            <AssetPanel
                assetType={'sound'}
                disabled={this.state.disabled}
                dragType={DragConstants.SOUND}
                fileAccept={'.wav, .mp3'}
                fileInput={this.setFileInput}
                playingIndex={this.state.playingIndex}
                items={sounds}
                selectedItemIndex={this.state.selectedSoundIndex}
                onChangeName={this.handleUpdateName}
                onClickAddFromLibrary={this.props.onNewSoundFromLibraryClick}
                onClickNew={this.props.onNewSoundFromRecordingClick}
                onClickPlay={this.handleSoundPlay}
                onClickStop={this.handleSoundStop}
                onClickUpload={this.handleFileUploadClick}
                onDeleteClick={this.handleDeleteSound}
                onDrop={this.handleDrop}
                onDuplicateClick={this.handleDuplicateSound}
                onEditClick={this.handleEditSound}
                onFileChange={this.handleSoundUpload}
                onItemClick={this.handleSelectSound}
            >
                {this.props.soundRecorderVisible ? (
                    <RecordModal
                        onNewSound={this.handleNewSound}
                    />
                ) : null}
                {this.props.soundLibraryVisible ? (
                    <SoundLibrary
                        vm={this.props.vm}
                        onNewSound={this.handleNewSound}
                        onRequestClose={this.props.onRequestCloseSoundLibrary}
                    />
                ) : null}
                {this.props.soundEditorVisible ? (
                    <SoundEditorModal soundIndex={this.state.selectedSoundIndex} />
                ) : null}
            </AssetPanel>
        );
    }
}

SoundPanel.propTypes = {
    editingTarget: PropTypes.string,
    onActivateCostumesTab: PropTypes.func.isRequired,
    onCloseImporting: PropTypes.func.isRequired,
    onNewSoundFromLibraryClick: PropTypes.func.isRequired,
    onNewSoundFromRecordingClick: PropTypes.func.isRequired,
    onRequestCloseSoundLibrary: PropTypes.func.isRequired,
    onRequestOpenSoundEditor: PropTypes.func.isRequired,
    onShowImporting: PropTypes.func.isRequired,
    soundEditorVisible: PropTypes.bool,
    soundLibraryVisible: PropTypes.bool,
    soundRecorderVisible: PropTypes.bool,
    sprites: PropTypes.shape({
        id: PropTypes.shape({
            sounds: PropTypes.arrayOf(PropTypes.shape({
                name: PropTypes.string.isRequired
            }))
        })
    }),
    stage: PropTypes.shape({
        sounds: PropTypes.arrayOf(PropTypes.shape({
            name: PropTypes.string.isRequired
        }))
    }),
    vm: PropTypes.instanceOf(VM).isRequired
};

const mapStateToProps = state => ({
    editingTarget: state.scratchGui.targets.editingTarget,
    sprites: state.scratchGui.targets.sprites,
    stage: state.scratchGui.targets.stage,
    soundEditorVisible: state.scratchGui.modals.soundEditor,
    soundLibraryVisible: state.scratchGui.modals.soundLibrary,
    soundRecorderVisible: state.scratchGui.modals.soundRecorder
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    onActivateCostumesTab: () => dispatch(activateTab(COSTUMES_TAB_INDEX)),
    onNewSoundFromLibraryClick: e => {
        if (ownProps.vm.editingTarget.disabled) {
            alert('不要改动老师已经写好的角色，会影响你正常过关'); // eslint-disable-line
            return;
        }
        e.preventDefault();
        dispatch(openSoundLibrary());
    },
    onNewSoundFromRecordingClick: () => {
        if (ownProps.vm.editingTarget.disabled) {
            alert('不要改动老师已经写好的角色，会影响你正常过关'); // eslint-disable-line
            return;
        }
        dispatch(openSoundRecorder());
    },
    onRequestCloseSoundLibrary: () => {
        dispatch(closeSoundLibrary());
    },
    onRequestOpenSoundEditor: () => {
        dispatch(openSoundEditor());
    },
    onCloseImporting: () => dispatch(closeAlertWithId('importingAsset')),
    onShowImporting: () => dispatch(showStandardAlert('importingAsset'))
});

export default errorBoundaryHOC('Sound Tab')(
    injectIntl(connect(
        mapStateToProps,
        mapDispatchToProps
    )(SoundPanel))
);
